import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.medias = {
      width: '100%',
      alignSelf: 'flex-start',
      justifySelf: 'flex-end',
      display: 'flex',
      position: ['relative', null, 'sticky'],
      top: ['initial', null, 'calc(var(--header-height, 0px) + 10px)'],
    };

    this.swiper = {
      flex: 1,
      position: 'relative',
    };

    this.slide = {
      m: 0,
      outline: 'none',
    };

    this.bullets = {
      mt: 6,
      display: ['flex', null, 'none'],
      justifyContent: 'center',
      gap: 9,
      width: '100%',
      height: '8px',
      '.swiper-pagination-bullet-active': {
        bg: 'text',
      },
      '.swiper-pagination-bullet': {
        cursor: 'pointer',
      },
    };
  })()
);
